module.exports = __webpack_public_path__ + "img/NoData.cb7b4d25.png";